import React, { PureComponent } from 'react';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class TrasladosLocalesForm extends PureComponent {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      ImpLocTrasladado: ['required', 'string', 'min:1'],
      TasadeTraslado: ['required', 'decimal:2'],
      Importe: ['required', 'decimal:2'],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.data && !!this.props.data && !!this.props.data.id && !this.state.data.id) {
      this.handleOnChange({
        ...this.props.data,
      });
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  };

  handleOnAdd = () => {
    const { data } = this.state;

    const newData = {
      ...data,
    };

    this.props.onAdd(newData);

    this.setState({
      data: {},
      isValid: false,
    });

    this.validate({});
  };

  render() {
    const { data, isValid } = this.state;
    const rules = this.rules;

    return (
      <>
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Nombre Impuesto Local Trasladado"
              name="ImpLocTrasladado"
              placeholder=""
              help=""
              rules={rules.ImpLocTrasladado}
              value={data.ImpLocTrasladado}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Tasa de Traslado"
              name="TasadeTraslado"
              rules={rules.TasadeTraslado}
              value={data.TasadeTraslado}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Importe"
              name="Importe"
              placeholder=""
              help=""
              rules={rules.Importe}
              value={data.Importe}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar traslado local
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default TrasladosLocalesForm;
